import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;
  text-align: center;
  font-family: Gilroy-Medium, sans-serif !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  font-size: 11px !important;
  color: rgba(255, 255, 255, 0.55) !important;
`;

export const Span = styled.span`
  margin: auto;
  line-height: normal;
`;
